export const isWeekend = (date: moment.Moment): boolean => date.day() === 0 || date.day() === 6
